// extracted by mini-css-extract-plugin
module.exports = {"parentContainer":"cardStyles__parentContainer___16wGQ","childContainer":"cardStyles__childContainer___2cJd8"};